import { graphql, useStaticQuery } from 'gatsby';
import {
    ILeaderData,
    LeaderCardQuery,
    LeadershipPageData,
} from '../LeaderPageTypes';
import { isDev } from '../../../shared/getEnv';
export const useLeaderCardQuery = (
    edic: boolean
): {
    leaders: ILeaderData[];
    page: LeadershipPageData;
} => {
    const viewData = useStaticQuery<LeaderCardQuery>(graphql`
        query LeaderGridCards {
            cardsDev: allNodeLeadershipBio(
                sort: [{ field_last_name: ASC }]
                filter: {
                    field_top_leadership: { eq: false }
                    moderation_state: { in: ["archived", "draft", "published"] }
                }
            ) {
                nodes {
                    title
                    field_last_name
                    field_leadership_position_title
                    field_secondary_info
                    field_top_leadership
                    field_edic
                    moderation_state
                    path {
                        alias
                    }
                    field_image {
                        alt
                    }
                    relationships {
                        field_image {
                            localFile {
                                childImageSharp {
                                    ...ImageLeaderImageCardSettings
                                }
                            }
                        }
                        field_hero_image {
                            field_media_image_1 {
                                alt
                                height
                                title
                                width
                            }
                            relationships {
                                field_media_image_1 {
                                    localFile {
                                        childImageSharp {
                                            ...ImageConstrainedSettings
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            cardsProd: allNodeLeadershipBio(
                sort: [{ field_last_name: ASC }]
                filter: {
                    field_top_leadership: { eq: false }
                    moderation_state: { in: ["published"] }
                }
            ) {
                nodes {
                    title
                    field_last_name
                    field_leadership_position_title
                    field_secondary_info
                    field_top_leadership
                    field_edic
                    path {
                        alias
                    }
                    field_image {
                        alt
                    }
                    relationships {
                        field_image {
                            localFile {
                                childImageSharp {
                                    ...ImageLeaderImageCardSettings
                                }
                            }
                        }
                        field_hero_image {
                            field_media_image_1 {
                                alt
                                height
                                title
                                width
                            }
                            relationships {
                                field_media_image_1 {
                                    localFile {
                                        childImageSharp {
                                            ...ImageConstrainedSettings
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            page: nodeLandingPage(path: { alias: { eq: "/leadership" } }) {
                field_landing_page_body {
                    value
                }
                relationships {
                    field_components {
                        type: __typename
                        ... on paragraph__leadership_text_row {
                            field_text
                            field_row_number
                        }
                    }
                }
            }
        }
    `);
    const { page, cardsDev, cardsProd } = viewData;
    const cards = isDev ? cardsDev : cardsProd;
    return {
        leaders: cards?.nodes?.filter((node) => node.field_edic === edic) || [],
        page,
    };
};
